import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "typed-text" }
const _hoisted_2 = { class: "typed" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default"),
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.typeValue), 1),
    _createElementVNode("span", {
      class: _normalizeClass(_ctx.caret + ' ' + { typing: _ctx.typeStatus })
    }, " ", 2)
  ]))
}